import * as React from 'react';

import { Container } from "./styles";
















export const Card = ({
  containerRef,
  children,
  defaultHoverBehavior,
  className,
  elevated,
  onClick,
  highlight,
  borderColor,
  loading,
  hasError,
  onContactButtonClick,
  testId }) => /*#__PURE__*/

React.createElement(Container, {

  ref: containerRef,
  className: className,
  defaultHover: defaultHoverBehavior,
  elevated: elevated,
  onClick: onClick,
  highlight: highlight,
  borderColor: borderColor,
  $loading: loading,
  hasError: hasError,
  $onContactButtonClick: onContactButtonClick },

children);